<a [href]="href"
	target="_blank"
	style="margin-left: 1em; font-size:12px;">
	<i class="fa fa-fw fa-external-link"></i>
	Make this a public UC Delivers Impact Story
</a>
